import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#004eeb",
  d: "M21 37a1 1 0 1 0 0 2v-2Zm14.5 2a1 1 0 1 0 0-2v2ZM18 11a1 1 0 1 0 0-2v2Zm-6-2a1 1 0 1 0 0 2V9Zm6 9a1 1 0 1 0 0-2v2Zm0 14a1 1 0 1 0 0-2v2Zm-6-16a1 1 0 1 0 0 2v-2Zm0 14a1 1 0 1 0 0 2v-2Zm13-13 .894-.447A1 1 0 0 0 25 16v1Zm7 14-.894.447A1 1 0 0 0 32 32v-1Zm1 0v1a1 1 0 0 0 1-1h-1Zm1.5-13a1 1 0 1 0 0-2v2ZM22 16a1 1 0 1 0 0 2v-2Zm9.5 0a1 1 0 1 0 0 2v-2ZM25 32a1 1 0 1 0 0-2v2Zm-3-2a1 1 0 1 0 0 2v-2Zm-1 9h14.5v-2H21v2ZM18 9h-6v2h6V9Zm-4 8v14h2V17h-2Zm1 1h3v-2h-3v2Zm0 14h3v-2h-3v2Zm0-16h-3v2h3v-2Zm0 14h-3v2h3v-2Zm8.5-12H25v-2h-1.5v2Zm.606-.553 7 14 1.788-.894-7-14-1.788.894ZM32 32h1v-2h-1v2Zm2-1V17h-2v14h2Zm-1-13h1.5v-2H33v2Zm-9.5-2H22v2h1.5v-2Zm9.5 0h-1.5v2H33v-2Zm-9.5 16H25v-2h-1.5v2Zm0-2H22v2h1.5v-2Zm-1-13v14h2V17h-2Z"
}, null, -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }